import styles from '../../styles/Components/Shared/DisplayRemainingCharacters.module.css';

const DisplayRemainingCharacters = ({ characterLimit, current, reservedCharacters = 0, disabled }) => {
    
    const currentLength = current && current.length ? current.length : 0;
    const characterLimitExceeded = characterLimit - currentLength - reservedCharacters < 0
    return (
        <p className={`${characterLimitExceeded ? styles.exceeded_characters : styles.remaining_characters} ${disabled ? styles.disabled : ''}`}>{currentLength} / {characterLimit - reservedCharacters}</p>
    ) 
}

export default DisplayRemainingCharacters;